import React, { useRef, useState } from "react";
import { amplify } from "../../service/api/AuthService";
import { Link } from "react-router-dom";
import NewUserForm from "../Login/NewUserForm.";
import "./SignUpPage.scss";
import LogoIcon from "../../assets/icons/LogoIcon";
import ArrowChevronLeftIcon from "../../assets/icons/ArrowChevronLeftIcon";
import Button from '@mui/material/Button';
import { Privacity } from "./Privacity";
import { Conditions } from "./Conditions";
import { isNumber, isRequired, lengthValidator, mailValidator, passwordValidator, repeatedPassword, identValidator, phoneValidator } from "../../utils/validators";
import { Cookies } from "./Cookies";
import Notification from "../../components/Notification/Notification";
import { createNotifyError } from "../../utils/helpers";

const fields = [
  {
    field: "contact",
    headerName: "Persona de contacto",
    validation: [(text) => isRequired(text), (text) => lengthValidator(text, 5, 255, true)],
  },
  {
    field: "company",
    headerName: "Introduce el nombre de tu empresa",
    validation: [(text) => isRequired(text)],
  },
  {
    field: "cif",
    headerName: "Introduce el identificador de tu empresa",
    validation: [(text) => isRequired(text), (text) => identValidator(text)],
  },
  {
    field: "address",
    headerName: "Dirección de tu empresa",
    validation: [(text) => isRequired(text)],
  },
  {
    field: "city",
    headerName: "Ciudad",
    validation: [(text) => isRequired(text)],
  },
  {
    field: "province",
    headerName: "Provincia",
    validation: [(text) => isRequired(text)],
  },
  {
    field: "postalCode",
    headerName: "Código postal",
    validation: [(text) => isRequired(text), (text) => isNumber(text)],
  },
  {
    field: "phoneContact",
    headerName: "Teléfono de contacto con extensión de país",
    validation: [(text) => isRequired(text), (text) => phoneValidator(text, 5, 255, true)],

  },
  {
    field: "email",
    headerName: "Email",
    validation: [(text) => isRequired(text), (text) => mailValidator(text, true)],
  },
  {
    field: "password",
    type: "password",
    headerName: "Contraseña",
    validation: [(text) => isRequired(text), (text) => passwordValidator(text, true)],
  },
  {
    field: "repeatPassword",
    type: "password",
    headerName: "Repetir Contraseña",
    validation: [repeatedPassword],
  },

];
const initialValues = Object.assign(
  ...fields.map((x) => ({ [x.field]: x.value || "" }))
);

const SignUpPage = (props) => {
  const { history } = props;
  const [loadingNewUser, setLoadingNewUser] = useState(false);
  const [notification, setNotification] = useState(undefined);
  const [mainForm, setMainForm] = useState(true);
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [cookies, setCookies] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [cookiesAccepted, setCookiesAccepted] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  const captchaRef = useRef(null);


  const onPrivacyAccepted = accepted => {
    setPrivacyAccepted(accepted);
  };

  const onTermsAccepted = accepted => {
    setTermsAccepted(accepted);
  };

  const onCookiesAccepted = accepted => {
    setCookiesAccepted(accepted);
  };

  const togglePrivacyInfo = showPrivacy => {
    setPrivacy(showPrivacy);
    setMainForm(!showPrivacy);
  };

  const toggleTermsInfo = showTerms => {
    setTerms(showTerms);
    setMainForm(!showTerms);
  };

  const toggleCookiesInfo = showCookies => {
    setCookies(showCookies);
    setMainForm(!showCookies);
  };

  const onClosePrivacy = returnback => {
    setPrivacy(!returnback);
    setMainForm(returnback);
  };

  const onCloseTearms = returnback => {
    setTerms(!returnback);
    setMainForm(returnback);
  };

  const onCloseCookies = returnback => {
    setCookies(!returnback);
    setMainForm(returnback);
  };

  const onSignUp = async (values) => {

    const { email, password, contact, phoneContact, company, cif, address, city, province, postalCode, sendComercialInfo } = values;
    const token = captchaRef.current.getValue();
    captchaRef.current.reset();


    amplify
      .signUp({
        username: email,
        password: password,
        attributes: {
          email: email,
          name: contact,
          phone_number: phoneContact,
          address: address,
          'custom:company_name': company,
          'custom:identification': cif,
          'custom:city': city,
          'custom:province': province,
          'custom:postal_code': postalCode,
          'custom:send_comercialinfo': sendComercialInfo === 'on' ? 'true' : 'false'
        },
        validationData: {
          captchaToken: token
        }
      })
      .then((user) => {
        if (user) {
          setShowModal(true);
        }
      })
      .catch(({ name }) => {
        setNotification(createNotifyError(name))
      })
      .finally(() => setLoadingNewUser(false));
  };

  const goBack = () => {
    if (mainForm) {
      return history.push({
        pathname: `/login`,
      });
    } else setMainForm(true);
  };

  return (
    <div className="sign-up">
      {notification && (
        <Notification
          notification={notification}
          setNotification={setNotification}
        />
      )}
      <div>
        <div className="row row align-items-center">
          <div className="col-md col-xl-6 left-side sign-up-left-side">
            <div className="row mt-4 gx-5 pe-4">
              <div className="col-sm-5 col-xl-5 p-4">
                <div className="logo-container">
                  <Link to="/login">
                    <LogoIcon fill={"#5c157d"} />
                  </Link>
                </div>
                <h1 className="container-welcome-solunion pt-2">
                  ¡Bienvenido!<br></br>
                  Accede y descubre
                  la forma más rápida de conocer
                  a tus socios comerciales.
                </h1>
              </div>
              <div className=" col-6 col-sm-6 col-md-6 col-lg-6 col-xl-7 d-flex d-inline pb-5 justify-content-end">
                <Button id="redirect-button" onClick={goBack}>
                  <ArrowChevronLeftIcon
                    fill={"#5c157d"}
                    width={24}
                    height={24}
                    className="chevron-left-icon"
                  />
                  <span className="ms-2">Volver</span>
                </Button>
              </div>
            </div>
          </div>


          <div className="col-12 pt-1 pt-xl-5 col-xl-6 right-side px-xl-5 ps-3 pe-1">
            <div className="col-sm-5 col-xl-5"><Link to="/login">
              <LogoIcon fill={"#5c157d"} className="login-body-container-logo-mobile" />
            </Link></div>
            <Button id="redirect-button-mobile" onClick={goBack}>
              <ArrowChevronLeftIcon
                fill={"#5c157d"}
                width={24}
                height={24}
                className="chevron-left-icon"
              />
              <span className="ms-2">Volver</span>
            </Button>
            <div className="container justify-content-start px-3 px-xl-0">
              {mainForm ?
                <div>
                  <h2 className="text-start display-6 d-flex d-inline mb-1 ps-0 mt-3">
                    Crea tu cuenta y comienza a disfrutar de las ventajas del servicio eGrade.</h2>
                  <p className="mb-4">Este es un producto dirigido exclusivamente a empresas. Utiliza los datos fiscales de tu empresa que aparecerán después en la factura
                    asociada a tu consumo de eGrade.</p>
                </div>
                :
                null
              }
              <div className="d-inline ">
                <div className="d-flex d-inline ">
                  {mainForm ?
                    <NewUserForm
                      addOrEdit={onSignUp}
                      loading={loadingNewUser}
                      setLoading={setLoadingNewUser}
                      privacyAccepted={privacyAccepted}
                      termsAccepted={termsAccepted}
                      cookiesAccepted={cookiesAccepted}
                      togglePrivacyInfo={togglePrivacyInfo}
                      toggleTermsInfo={toggleTermsInfo}
                      toggleCookiesInfo={toggleCookiesInfo}
                      values={values}
                      setValues={setValues}
                      fields={fields}
                      initialValues={initialValues}
                      errors={errors}
                      setErrors={setErrors}
                      showModal={showModal}
                      captchaRef={captchaRef}
                    />
                    : <>
                      {
                        privacy ?
                          <Privacity
                            onClosePrivacy={onClosePrivacy}
                            onPrivacyAccepted={onPrivacyAccepted}
                          />
                          : null
                      }
                      {
                        terms ?
                          <Conditions
                            onCloseTearms={onCloseTearms}
                            onTermsAccepted={onTermsAccepted}
                          />
                          : null
                      }
                      {
                        cookies ?
                          <Cookies
                            onCloseCookies={onCloseCookies}
                            onCookiesAccepted={onCookiesAccepted}
                          />
                          : null
                      }
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default SignUpPage;
